import axios from 'axios';
import {
  type PolicyGenerateDocumentUploadUrlInputBody,
  buildSignedUploadHeaders,
  policyControllerGenerateDocumentUploadUrl,
  toKeyValueFields,
} from '../';

export async function uploadDocumentsOnPolicy({
  policyId,
  branchId,
  payload,
}: {
  policyId: string;
  branchId?: string;
  payload: Omit<PolicyGenerateDocumentUploadUrlInputBody, 'metadata'> & {
    file: File;
    metadata: Record<string, string>;
  };
}): Promise<{ key: string }> {
  const { file, ...rest } = payload;

  const { url, id, contentType, contentDisposition } =
    await policyControllerGenerateDocumentUploadUrl(
      policyId,
      {
        ...rest,
        metadata: toKeyValueFields(rest?.metadata ?? []),
      } as PolicyGenerateDocumentUploadUrlInputBody,
      { branchId },
    );

  const headers = buildSignedUploadHeaders({
    contentType,
    contentDisposition,
    filename: payload.name,
    fallbackContentType: payload.file.type,
  });

  await axios.put(url, payload.file, { headers });

  return { key: id };
}
